import React from 'react';

export default {
  'en-US': {
    header: 'Important Information Regarding Investments in my529',
    paragraphs: [
      'The performance data shown above reflect past performance and are not an indication or guarantee of future results. Investment returns and principal value will fluctuate with market conditions. Investments, when sold, may be worth more or less than the original cost; in short, your investment could lose value.',

      'Investment returns take into account the underlying investment performance for each period, including applicable interest and dividends, and are net of fees. Personal rate of return may be lower or higher than the performance data cited. Individual account performance will vary relative to the stated performance depending on the timing of buy and sell transactions within each account.',

      'For the Target Enrollment Date investment option, the performance reflects changes in asset allocations over time relating to the target year the account beneficiary will begin withdrawing funds to pay for qualified education expenses.',

      <span key='important-info-paragraph4'>Most recent month-end total returns may be found at <a href='https://my529.org/performance-returns/'>https://my529.org/performance-returns/</a>.</span>,
    ],
  },
};
